import { useEffect } from "react";

import { useGetApi } from "../../../hooks";
import { getIds } from "../../../pages/Home/Home.utils";
import { useDispatch, useSelector } from "../../../redux/hooks";
import { setManagementLinks } from "../../../redux/slices/permsSlice";
/**
 * Custom hook to manage and fetch management links based on user permissions.
 *
 * @param fetchLinks - A boolean indicating whether to fetch management links on initialization.
 * @returns An object containing:
 * - `isAuthorizedToSeeLinks`: A boolean indicating if the user has permission to see management links.
 * - `managementLinks`: An array of management link IDs.
 */
const useManagementLinks = (fetchLinks?: boolean) => {
  const dispatch = useDispatch();
  const { managementLinks, management, clientAdmin } = useSelector(
    state => state.permsSlice,
  );
  const { data, refetch } = useGetApi({
    request: "get-home",
    fetchOnInit: false,
  });

  useEffect(() => {
    if (
      fetchLinks &&
      (!managementLinks || managementLinks.length === 0) &&
      (management || clientAdmin)
    ) {
      void refetch();
    }
  }, [fetchLinks, managementLinks, management, clientAdmin]);

  useEffect(() => {
    if (!data) return;
    const ids = getIds(data);
    if (ids) dispatch(setManagementLinks(ids));
  }, [data]);

  return { isAuthorizedToSeeLinks: management || clientAdmin, managementLinks };
};
export default useManagementLinks;
